import { create } from 'zustand';
import { User, Message, AdvancedFilters } from '../types';

interface ChatStore {
  user: User | null;
  messages: Message[];
  isConnected: boolean;
  currentPartner: User | null;
  activeUsersCount: number;
  advancedFilters: AdvancedFilters;
  setUser: (user: User) => void;
  addMessage: (message: Message) => void;
  setIsConnected: (status: boolean) => void;
  setCurrentPartner: (partner: User | null) => void;
  setActiveUsersCount: (count: number) => void;
  setAdvancedFilters: (filters: AdvancedFilters) => void;
  clearChat: () => void;
  startNewSearch: () => void;
}

const defaultFilters: AdvancedFilters = {
  ageRange: [18, 60],
  interests: [],
  location: '',
  language: 'any',
  showOnlineOnly: false,
};

export const useStore = create<ChatStore>((set) => ({
  user: null,
  messages: [],
  isConnected: false,
  currentPartner: null,
  activeUsersCount: 0,
  advancedFilters: defaultFilters,
  setUser: (user) => set({ user }),
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),
  setIsConnected: (status) => set({ isConnected: status }),
  setCurrentPartner: (partner) => set({ currentPartner: partner }),
  setActiveUsersCount: (count) => set({ activeUsersCount: count }),
  setAdvancedFilters: (filters) => set({ advancedFilters: filters }),
  clearChat: () => set({ messages: [], currentPartner: null }),
  startNewSearch: () => set(() => ({
    messages: [],
    currentPartner: null,
  })),
}));

